import React, { createContext, useState, useContext, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem('theme');
    return saved ? saved === 'dark' : true;
  });

  useEffect(() => {
    localStorage.setItem('theme', isDark ? 'dark' : 'light');
    if (isDark) {
      document.body.classList.remove('light-theme');
    } else {
      document.body.classList.add('light-theme');
    }
  }, [isDark]);

  const toggleTheme = () => setIsDark(!isDark);

  const theme = {
    isDark,
    toggleTheme,
    colors: isDark ? {
      // Dark theme (current)
      background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 100%)',
      headerBg: 'rgba(0, 0, 0, 0.95)',
      text: '#ffffff',
      textSecondary: 'rgba(255, 255, 255, 0.7)',
      border: 'rgba(255, 255, 255, 0.1)',
      accent: '#00ff88',
      accentGradient: 'linear-gradient(135deg, #00ff88 0%, #00cc6a 100%)',
      cardBg: 'rgba(255, 255, 255, 0.05)',
      footerBg: 'rgba(10, 20, 30, 0.98)'
    } : {
      // Light theme (Zerodha-style)
      background: '#ffffff',
      headerBg: '#ffffff',
      text: '#424242',
      textSecondary: '#666666',
      border: '#e0e0e0',
      accent: '#387ed1',
      accentGradient: 'linear-gradient(135deg, #387ed1 0%, #2563eb 100%)',
      cardBg: '#f8f9fa',
      footerBg: '#f5f5f5'
    }
  };

  return (
    <ThemeContext.Provider value={theme}>
      {children}
    </ThemeContext.Provider>
  );
};
